import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {Router} from '@angular/router';
import 'rxjs/add/operator/do';
import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,
  HttpResponse, HttpXsrfTokenExtractor
} from '@angular/common/http';
import {OperatingStandardService} from './operating-standard.service';
import 'rxjs/add/operator/map';
import {CookieService} from 'ngx-cookie-service';
import {AuthService} from './auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private router: Router,
              private cookie: CookieService,
              private tokenExtractor: HttpXsrfTokenExtractor,
              private injector: Injector) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const operatingStandardService = this.injector.get(OperatingStandardService);
    const headerName = 'X-XSRF-TOKEN';
    const token = this.tokenExtractor.getToken() as string;

    let reqTemp = req;
    if (token !== null && !req.headers.has(headerName)) {
      reqTemp = req.clone({
        headers: req.headers.set(headerName, token)
      });
    }
    // set('Cookie', this.cookie.getAll().toString())

    return next.handle(reqTemp)
      .do((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (event.headers.get('NOTIFY-ME')) {
              operatingStandardService.notificationCountManager(event.headers.get('NOTIFY-ME'));
            }
          }
        }
      )
      .catch(err => {
        if (err instanceof HttpErrorResponse) {
          if (this.shouldClearClientSession(err)) {
            this.clearClientSession();
          }
        }
        return Observable.throw(err);
      });
  }

  private shouldClearClientSession(err: HttpErrorResponse): boolean {
    if (err.status === 401) {
      return true;
    }
    if (err.status !== 403) {
      return false;
    }
    return !this.hasBusinessForbiddenPayload(err.error);
  }

  private hasBusinessForbiddenPayload(error: any): boolean {
    if (error === null || error === undefined || error === '') {
      return false;
    }
    if (typeof error !== 'object') {
      return false;
    }
    return error.errorCode !== undefined || error.code !== undefined;
  }

  private clearClientSession(): void {
    const authService = this.injector.get(AuthService, null);
    if (authService !== null) {
      authService.clearClientSession();
    } else {
      this.clearClientSessionFallback();
    }
    this.router.navigate(['signin']);
  }

  private clearClientSessionFallback(): void {
    const lang = localStorage.getItem('lang');
    localStorage.clear();
    if (lang !== null) {
      localStorage.setItem('lang', lang);
    }
    if (this.cookie && this.cookie.deleteAll) {
      this.cookie.deleteAll();
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/error-interceptor.service.ts